@switch (columnName) {
  @case ('user') {
    {{ element.user?.name }}
  }
  @case ('doneBy') {
    {{ element.doneBy?.name }}
  }
  @case ('updatedAt') {
    {{ element.updatedAt | date: dateTimeFormat }}
  }
  @case ('status') {
    <app-ui-pill [name]="ADDITIONAL_TIME_APPROVAL_STATUS[element.status]"></app-ui-pill>
  }
  @case ('type') {
    {{ element.isWork ? ('manualWork' | translate) : ('manualRest' | translate) }}
  }
  @case ('department') {
    {{ element.department?.name }}
  }
  @case ('departments') {
    @for (department of element.departments; track department.id) {
      <div>
        {{ department?.name }}
      </div>
    }
    @for (departmentGroup of element.departmentGroups; track departmentGroup.id) {
      <div>
        {{ departmentGroup?.name }}
      </div>
    }
  }
  @case ('from') {
    {{ element.from | timeDisplay }}
  }
  @case ('to') {
    {{ element.to | timeDisplay }}
  }
  @case ('totalAmountOfHours') {
    {{ element.totalAmountOfHours | numberRound }}
  }
  @case ('edit') {
    <button mat-button (click)="buttonFunctions.edit()">
      <mat-icon>edit</mat-icon>
    </button>
  }
  @case ('delete') {
    <button mat-button (click)="buttonFunctions.delete()">
      <mat-icon>delete</mat-icon>
    </button>
  }
  @default {
    <app-default-cell [element]="element" [columnName]="columnName"></app-default-cell>
  }
}
